import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/auth.service.ts';
import { adminService } from '../services/admin.service.ts';

/** Giriş + admin yetkisi zorunlu. */
function AdminRoute({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<'loading' | 'ok' | 'denied' | 'anon'>('loading');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!authService.isAuthenticated()) {
        if (!cancelled) setState('anon');
        return;
      }
      const ok = await adminService.checkStatus();
      if (!cancelled) setState(ok ? 'ok' : 'denied');
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (state === 'loading') {
    return (
      <div className="min-h-[40vh] flex items-center justify-center text-gray-400 text-sm">
        Yetki kontrol ediliyor…
      </div>
    );
  }
  if (state === 'anon') return <Navigate to="/login" replace />;
  if (state === 'denied') return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}

export default AdminRoute;
